import { fromJS } from 'immutable';
import * as actions from '../../actions/appraisalDemo/global';
import { fetchingState } from '../../constants';
import Lodash from 'lodash';

const initialStats = {
  preference: {},
  editData: {},
  currentSavedSearchIndex: 0,
  currentSearch: {},
  selectedProperty: '',
  selectedYear: '2019',
  isMenuVisible: false,
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.PREFERENCE_FETCH_START:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case actions.PREFERENCE_FETCH_SUCCESS: {
      const newState = state.setIn(
        ['preference', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    }
    case actions.PREFERENCE_FETCH_ERROR:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case actions.PREFERENCE_PERSIST_SUCCESS:
      return state
        .setIn(['preference', 'state'], fetchingState.LOADED)
        .setIn(
          ['preference', 'data'],
          fromJS(
            action.data.results.length > 0
              ? action.data.results[0].preference
              : {},
          ),
        );

    case actions.VIEW_NEXT_SAVED_SEARCH:
      return state.set(
        'currentSavedSearchIndex',
        state.get('currentSavedSearchIndex') + 1,
      );
    case actions.VIEW_PREV_SAVED_SEARCH:
      return state.set(
        'currentSavedSearchIndex',
        state.get('currentSavedSearchIndex') - 1,
      );
    case actions.CHANGE_SAVED_SEARCH:
      return state.set('currentSavedSearchIndex', action.data);

    case actions.SAVE_CURRENT_SEARCH:
      return state.set('currentSearch', fromJS(action.data));

    case actions.SELECT_PROPERTY:
      return state.set('selectedProperty', action.data);
    case actions.SELECT_YEAR:
      return state.set('selectedYear', action.data);

    case actions.INIT_EDIT_DATE:
      return state.setIn(['editData', action.title], fromJS(action.data));
    case actions.UPDATE_EDIT_DATE:
      let newEditData = state.getIn(['editData', action.title]).toJS();
      newEditData[action.key] = Lodash.uniqBy(action.data);
      return state.setIn(['editData', action.title], fromJS(newEditData));
    case actions.REMOVE_EDIT_DATE:
      newEditData = state.getIn(['editData', action.title, action.key]).toJS();
      const index = newEditData.findIndex((value) => value === action.data);
      newEditData.splice(index, 1);
      return state.setIn(
        ['editData', action.title, action.key],
        fromJS(newEditData),
      );

    case actions.TOGGLE_MENU:
      return state.set('isMenuVisible', !state.get('isMenuVisible'));
    default:
      return state;
  }
};
